import { FC, useRef } from 'react';
import { useLogging } from '../hooks/common/useLogging';
import { useShippingAddress } from '../hooks/ShippingAddress/useShippingAddress';
import { useEmitResetWindow } from '../hooks/common/useEmitResetWindow';
import { Setting } from '../App';
import { SectionTitle } from '../components/common/SectionTitle';
import { InformationBox } from '../components/common/InformationBox';
import { NavigationWrapper } from '../components/common/NavigationWrapper';
import { Button } from '../components/common/Button';
import { ShippingAddressDetail } from '../components/ShippingAddress/ShippingAddressDetail';

export const ShippingAddress: FC<{ setting: Setting }> = ({ setting }) => {

  const { subscriptionRef } = setting;
  const [{ subscription, loadingSubscriptions }] = subscriptionRef;
  const shippingAddress = useShippingAddress(subscription);

  const rootElementReference = useRef<HTMLDivElement | null>(null);
  useEmitResetWindow(rootElementReference, [shippingAddress]);

  useLogging('ShippingAddress', [shippingAddress]);

  return (
    <div 
      className={`appContainer shippingAddress`}
      ref={rootElementReference}
    >
      <SectionTitle>お届け先情報の確認</SectionTitle>
      <InformationBox title="現在のお届け先">
        <>
          <ShippingAddressDetail title="姓" value={shippingAddress?.lastName}/>
          <ShippingAddressDetail title="名" value={shippingAddress?.firstName}/>
          {shippingAddress?.company && (
            <ShippingAddressDetail title="会社名" value={shippingAddress?.company}/>
          )}
          <ShippingAddressDetail title="電話番号" value={shippingAddress?.phone}/>
          <ShippingAddressDetail title="郵便番号" value={shippingAddress?.zip && `〒${shippingAddress.zip}`}/>
          <ShippingAddressDetail title="国/地域" value={shippingAddress?.countryData?.name}/>
          <ShippingAddressDetail title="都道府県" value={
            shippingAddress?.countryData ?
              shippingAddress.countryData.zones.filter(zone => zone.code === shippingAddress.provinceCode)[0].name
              : undefined
          }/>
          <ShippingAddressDetail title="市町村区" value={shippingAddress?.city}/>
          <ShippingAddressDetail title="住所" value={shippingAddress?.address1}/>
          <ShippingAddressDetail title="建物名・部屋番号など" value={shippingAddress?.address2}/>
        </>
      </InformationBox>
      <NavigationWrapper>
        <Button internalLink={'/shippingAddress/form'} type="primary" disabled={loadingSubscriptions}>変更する</Button>
        <Button internalLink={'/'} type="secondary">もどる</Button>
      </NavigationWrapper>
    </div>
  );
};
